import 'whatwg-fetch';

export default (...args: any[]) => window.fetch.apply(window, args);
